import React from 'react'
import { Skeleton } from '@mui/material'
import { SKELETON_TAG_HEIGHT } from './constants'
import { SkeletonContainer } from './styles'

const ShiftsSkeleton: React.FC = () => (
  <SkeletonContainer>
    <Skeleton variant="rectangular" width="50%" height={SKELETON_TAG_HEIGHT} />
  </SkeletonContainer>
)

export default ShiftsSkeleton
